import { cx } from "shared/utils";
import { useSoftphone } from "./SoftphoneProvider";
import { SOFTPHONE_OVERLAY_Z_CLASS } from "./stacking";

/**
 * Shown while the softphone is in `mic-denied` state. Explains the issue and
 * gives the user a way to retry registration once they've changed the browser
 * permission. Safe to render at the app root — it's null-op otherwise.
 */
export function MicDeniedBanner() {
  const { status, retryRegistration } = useSoftphone();

  if (status !== "mic-denied") return null;

  return (
    <div
      role="alert"
      className={cx(
        "fixed left-1/2 top-4 -translate-x-1/2 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-lg",
        SOFTPHONE_OVERLAY_Z_CLASS
      )}
    >
      <p className="font-medium">Microphone access is required</p>
      <p className="mt-1 text-xs text-amber-800">
        Click the lock icon next to the URL, allow microphone access, then
        retry.
      </p>
      <button
        type="button"
        onClick={retryRegistration}
        className="mt-2 rounded bg-amber-600 px-3 py-1 text-xs font-medium text-white"
      >
        Retry
      </button>
    </div>
  );
}
